import React from 'react';
import PlannerFrame from './PlannerFrame';

const CriticalMineralsDashboard = () => {
  return (
    <PlannerFrame
      title="Global Critical Mineral Transport Infrastructure Planning"
      src="/Critical_Minerals_Dashboard_beta.html"
    />
  );
};

export default CriticalMineralsDashboard;
